<template>
  <el-dialog
    title="待付款清单"
    v-model="dialog.show"
    :before-close="handleClose"
    :close-on-click-modal="false"
    class="pledging-payment-detail-payTable-dialog"
    width="70%"
  >
    <ab-list-query>
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="订单编号"
              v-model.trim="formSearch.coreBillNumbers"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="4">
            <ab-select
              v-model="formSearch.unitIdDesc"
              url="/bas/client/basSupplier/list"
              :urlData="{ name: formSearch.unitIdDesc, pageNum: 1, pageSize: 10, isEnabled: 1 }"
              inputKey="nameOrNumber"
              descKey="name"
              placeholder="供应商"
              @handleSelect="unitSelect"
            ></ab-select>
          </el-col>
          <el-col :span="4">
            <el-date-picker
              v-model="formSearch.billDate"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              type="date"
              placeholder="订单日期"
            ></el-date-picker>
          </el-col>
          <el-col
            :span="8"
            class="text-left"
          >
            <el-button @click="searchForm">搜索</el-button>
            <el-button
              link
              class="btn-svg"
              @click="resetForm"
            >
              <ab-svg name="qingchu"></ab-svg>清除
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showSelection
          showOrder
          selectionWidth="45"
          indexWidth="50"
          :height="350"
          :column-list="columnsArrys"
          :table-list="tableData"
          :dataListLoading="loading.table"
          :handleSelectionChange="selectionChange"
          :selectable="selectable"
          :select="selection"
        ></ab-table>
        <div class="table-count">
          已选订单：
          <span
            v-for="([currency, money]) of Object.entries(totalAmount)"
            :key="currency"
            class="amount"
          >{{ $filters.formatMoney(money) }}&nbsp;{{ currency }}</span>
        </div>
      </template>
    </ab-list-query>

    <template #footer>
      <div class="dialog-footer">
        <!-- <span class="tips">*地址说明：选择客户地址请提供与下游客户的盖章订单；选择代工厂请提供代工合同。</span> -->
        <el-button
          type="primary"
          @click="handlerSave"
          :disabled="!multiSelected.length"
          :loading="loading.confirmBtn"
        >确 认</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'pledging-payment-detail-payTable-dialog', // 待付款清单
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    paymentAppVo: {
      type: Object
    }
  },
  data () {
    return {
      loading: {
        table: false,
        confirmBtn: false
      },

      // 搜索条件
      formSearch: {},

      // 表格数据
      columns: [
        {
          labels: '订单编号',
          props: 'clientBillNumber',
          widths: '150'
        },
        {
          labels: '订单日期',
          props: 'bizDate',
          widths: '90'
        },
        {
          labels: '计费项目',
          props: 'expenseItemName',
          widths: '80'
        },
        {
          labels: '供应商',
          props: 'supplierName',
          widths: '220'
        },
        {
          labels: '客户',
          props: 'customerName',
          widths: '220'
        },
        {
          labels: '可付金额',
          props: 'prePaymentAmount',
          type: 'money',
          align: 'right',
          widths: '130'
        },
        {
          labels: '币别',
          props: 'settleCurrencyName',
          widths: '80'
        }
      ],
      tableData: [],

      multiSelected: [],

      multipleSelectionRows: {},

    }
  },
  watch: {
    'dialog.show' (value) {
      if (value) {
        this.formSearch.unitId = this.dialog.data.unitId
        this.formSearch.unitIdDesc = this.dialog.data.unitIdDesc
        this.searchForm()
      }
    }
  },
  computed: {
    columnsArrys () {
      if (['01', '02'].includes(this.paymentAppVo.bizType)) {
        return this.columns.filter(e => { return e.props != 'customerName'})
      } else if (['03', '04', '06'].includes(this.paymentAppVo.bizType)) {
        return this.columns.filter(e => { return e.props != 'supplierName'})
      } else {
        return this.columns
      }
    },
    totalAmount () {
      let dict = {}
      this.multiSelected.map(row => {
        if (dict.hasOwnProperty(row.settleCurrencyName)) {
          dict[row.settleCurrencyName] = this.$calc.add(dict[row.settleCurrencyName], row.prePaymentAmount)
        } else {
          dict[row.settleCurrencyName] = row.prePaymentAmount
        }
      })

      return dict
    }
  },
  methods: {
    searchForm () {
      let data = Object.assign({}, this.dialog.data, this.formSearch)
      this.tableData = []
      this.loading.table = true
      this.$post('/sms/client/paymentApp/preDataList', { isPage: false, data })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.tableData = data.result.list || []
          }
        })
        .finally(() => {
          this.loading.table = false
        })
    },
    resetForm () {
      this.formSearch = {
        coreBillNumbers: '',
        unitId: '',
        unitIdDesc: '',
        billDate: ''
      }
    },
    selectionChange (array) {
      this.multiSelected = array
    },
    handlerSave () {
      this.$emit('on-confirm', this.multiSelected)
      this.handleClose()
    },
    handleClose () {
      this.formSearch = {}
      this.tableData = []
      this.multiSelected = []
      this.multipleSelectionRows = {}
      this.dialog.show = false
    },
    unitSelect(row) {
      if (row && row.id) {
        this.formSearch.unitId = row.id
      } else {
        this.formSearch.unitId = ''
      }
    },
    // 待付款清单勾选
    selection(selection, row) {
      if (selection.includes(row)) {
          this.tableData.map((item) => {
            if (
              item !== row &&
              !selection.includes(item) &&
              item.coreBillNumber === row.coreBillNumber
            ) {
              this.$refs.table.$refs['table-list'].toggleRowSelection(item)
            }
          })
        }

        this.multipleSelectionRows = {}
        this.multiSelected.map((item) => {
          if (!this.multipleSelectionRows[item.coreBillNumber]) {
            this.multipleSelectionRows[item.coreBillNumber] = {}
            this.multipleSelectionRows[item.coreBillNumber].slave = []
          }

          if (item.cashDirection === 2) {
            this.multipleSelectionRows[item.coreBillNumber].main = item
          } else {
            this.multipleSelectionRows[item.coreBillNumber].slave.push(item)
          }
        })
    },
    // 待付款清单勾选过滤
    selectable(row) {
        if (!this.multiSelected.length) {
          return true
        }

        if (this.multipleSelectionRows[row.coreBillNumber]) {
          if (
            row === this.multipleSelectionRows[row.coreBillNumber].main &&
            this.multipleSelectionRows[row.coreBillNumber].slave.length
          ) {
            return false
          }
        }

        return true
      },

  }
}
</script>

<style lang="scss">
.pledging-payment-detail-payTable-dialog {
  .el-dialog__body {
    padding: 0;
    .el-menu, .toolbar, .list-page {
      display: none;
    }
  }

  .table {
    margin-top: 8px;
  }
  .el-table {
    .el-scrollbar__thumb {
      width: 6px;
    }
  }

  .table-count {
    margin-top: 10px;
    .amount {
      color: #f56c6c;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .query-list {
    margin-top: 20px!important;
  }
}
</style>
